module.exports = __webpack_public_path__ + "media/images/Ilan-9fc0e93153bd0e35f8297554eb92d04a.jpg";